/**
 * `request_tracker.digest` (M263, card 4c): the weekly verification email of the request tracker. Two:
 *
 *   digest_enabled   send it (Monday 08:00 America/Denver, TRACKER_DIGEST_CRON). Off: nothing is read
 *                    beyond the switch and nothing is sent (API services/tracker/tracker-digest.ts).
 *   digest_days      a shipped request waiting on a confirmation for more than this many days counts
 *                    as stale in the email (the funnel's window, data/tracker-funnel.ts; default 14).
 *
 * Recipients are not a setting: the tracker's hardcoded allowlists (security/request-tracker-whitelist.ts,
 * the client and dev email lists; Noah keeps them in code).
 *
 * Who: editPermission feature:system_settings, AIG accounts only (`aigOnly`: the tracker and its lists
 * are AIG's). No readPermission: only the job reads the values. Edited on Settings → App settings.
 * Default off.
 */
import { z } from 'zod';
import { defineGroup } from '../define.js';
export const requestTrackerDigest = defineGroup('request_tracker.digest', {
    label: 'Request tracker weekly email',
    editPermission: 'feature:system_settings',
    aigOnly: true,
    settings: {
        digest_enabled: {
            type: z.boolean(),
            default: false,
            label: 'Send the weekly verification email',
            help: 'On Monday mornings, the request tracker’s client and AIG lists get an email of the shipped requests still waiting on a confirmation (nobody gets one when nothing is waiting).',
        },
        digest_days: {
            type: z.number().int().min(1).max(90),
            default: 14,
            label: 'Waiting too long after (days)',
            help: 'A shipped request waiting on a confirmation for more than this many days is listed as waiting too long.',
        },
    },
});
//# sourceMappingURL=request-tracker.js.map